var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', _vm._b({
    attrs: {
      "stitch": "",
      "fill-height": ""
    }
  }, 'ModalContent', _vm.modalProps, false), [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("title")))]), _c('template', {
    slot: "rawcontent"
  }, [_c('div', {
    staticClass: "assign-product-catalogs-modal d-flex flex-column min-height-0 h-100"
  }, [_vm.loading ? _c('Loading', {
    attrs: {
      "absolute": false
    }
  }) : !_vm.catalogs.length ? _c('div', {
    staticClass: "assign-product-catalogs-discovery pa-6"
  }, [_c('DiscoveryCard', {
    attrs: {
      "illustration": _vm.catalogDiscovery,
      "loading": _vm.creatingCatalog
    },
    on: {
      "choose": _vm.createCatalog
    }
  })], 1) : _vm.step === 'piece_content' ? _c('div', {
    staticClass: "assign-product-catalogs-modal-content d-flex flex-column flex-grow-1 min-height-0 pa-4"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-4"
  }, [_c('v-btn', {
    staticClass: "px-0",
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.step = 'select';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.$translate("buttons.backToSelection")) + " ")], 1)], 1), _c('Info', {
    staticClass: "mb-4",
    attrs: {
      "elevation": 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("messages.pieceContentDescription")) + " ")]), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.pieceContentForm.quantity,
      "label": _vm.$translate('labels.pieceContentQuantity'),
      "error-messages": _vm.pieceContentErrors.quantity,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "type": "text",
      "inputmode": "decimal"
    },
    on: {
      "input": function input($event) {
        _vm.pieceContentForm.quantity = _vm.$utils.normalizeDecimalString($event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.pieceContentUnitOptions,
      "label": _vm.$translate('labels.pieceContentUnit'),
      "error-messages": _vm.pieceContentErrors.unit,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.pieceContentForm.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.pieceContentForm, "unit", $$v);
      },
      expression: "pieceContentForm.unit"
    }
  })], 1)], 1)], 1) : _c('div', {
    staticClass: "assign-product-catalogs-modal-content d-flex flex-column flex-grow-1 min-height-0"
  }, [_c('div', {
    staticClass: "flex-shrink-0 pt-4 px-4"
  }, [_c('div', {
    staticClass: "text-body-2 mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$translate("messages.instructions")) + " ")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "outlined": "",
      "loading": _vm.creatingCatalog
    },
    on: {
      "click": _vm.createCatalog
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$translate("buttons.createCatalog")) + " ")], 1)], 1)]), _c('div', {
    staticClass: "assign-product-catalogs-modal-list flex-grow-1 min-height-0 overflow-y-auto px-4 pb-4"
  }, _vm._l(_vm.catalogs, function (catalog) {
    return _c('v-card', {
      key: catalog.id,
      staticClass: "assign-catalog-card mb-3",
      "class": {
        'assign-catalog-card--active': _vm.isCatalogAssigned(catalog.id)
      },
      attrs: {
        "outlined": ""
      }
    }, [_c('div', {
      staticClass: "assign-catalog-card__header px-4 pt-3"
    }, [_c('div', {
      staticClass: "min-width-0"
    }, [_c('div', {
      staticClass: "text-subtitle-1 font-weight-medium text-truncate"
    }, [_vm._v(" " + _vm._s(catalog.name) + " ")]), _vm.isProviderProduct ? _c('div', {
      staticClass: "text-caption grey--text text-truncate"
    }, [_vm._v(" " + _vm._s(_vm.catalogOwnerDisplayName(catalog)) + " ")]) : _vm._e()]), _c('v-chip', {
      staticClass: "flex-shrink-0",
      attrs: {
        "x-small": "",
        "label": ""
      }
    }, [_vm._v(" " + _vm._s(catalog.prices_include_vat ? _vm.$translate("labels.inclVat") : _vm.$translate("labels.exclVat")) + " ")])], 1), _c('div', {
      staticClass: "px-4 pb-2"
    }, [_vm._l(_vm.stateFor(catalog.id).rows, function (row, rowIndex) {
      return [rowIndex > 0 ? _c('v-divider', {
        key: "divider-".concat(catalog.id, "-").concat(row.key),
        staticClass: "assign-catalog-card__divider"
      }) : _vm._e(), _c('div', {
        key: "row-".concat(catalog.id, "-").concat(row.key),
        staticClass: "assign-catalog-card__row"
      }, [_c('FormatSelect', {
        ref: "formatSelect-".concat(catalog.id, "-").concat(row.key),
        refInFor: true,
        attrs: {
          "value": row.formatId,
          "formats": _vm.formats,
          "label": _vm.$translate('labels.format'),
          "unit-option-label": _vm.unitOptionLabel,
          "show-create-option": _vm.canCreateFormat,
          "variant": "sale",
          "hide-details": "auto",
          "input-class": "assign-catalog-card__format"
        },
        on: {
          "input": function input($event) {
            return _vm.onRowFormatChange(row, $event);
          },
          "create-format": function createFormat($event) {
            return _vm.createFormatForRow(catalog.id, row);
          }
        }
      }), _c('v-text-field', {
        staticClass: "assign-catalog-card__price",
        attrs: {
          "value": row.price,
          "label": _vm.unitAmountLabel(catalog),
          "type": "text",
          "inputmode": "decimal",
          "dense": "",
          "outlined": "",
          "hide-details": "auto",
          "prefix": "€"
        },
        on: {
          "input": function input($event) {
            return _vm.onRowPriceChange(row, $event);
          }
        }
      }), _c('span', {
        staticClass: "assign-catalog-card__row-action"
      }, [_c('v-btn', {
        attrs: {
          "icon": "",
          "small": "",
          "title": _vm.$translate('buttons.removeEntry')
        },
        on: {
          "click": function click($event) {
            return _vm.removeRow(catalog.id, row);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v(" mdi-delete-outline ")])], 1)], 1)], 1)];
    }), !_vm.stateFor(catalog.id).rows.length ? _c('div', {
      staticClass: "d-flex align-center justify-space-between py-2"
    }, [_c('span', {
      staticClass: "text-body-2 grey--text"
    }, [_vm._v(" " + _vm._s(_vm.$translate("messages.noEntries")) + " ")]), _c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.addRow(catalog.id);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$translate("buttons.add")) + " ")], 1)], 1) : _c('div', {
      staticClass: "mt-1 mb-2"
    }, [_c('v-btn', {
      staticClass: "px-1",
      attrs: {
        "text": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.addRow(catalog.id);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$translate("buttons.addEntry")) + " ")], 1)], 1)], 2)]);
  }), 1)])], 1)]), _c('template', {
    slot: "bottom"
  }, [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.cancel")) + " ")]), _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "color": _vm.assignedCount > 0 ? 'primary' : null,
      "disabled": _vm.saving,
      "loading": _vm.saving
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm.assignedCount > 0 ? _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-content-save")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.saveText) + " ")], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }